import { RouteItem } from '@eastcoal/router/types/route'

import {
  BANNER_CREATE_PAGE_PATH,
  BANNER_EDIT_PAGE_PATH,
  BANNER_LIST_PAGE_PATH
} from './constants/path'
import { BANNER_LIST_PAGE_UUID, BANNER_ACTION_UUID } from './constants/uuid'

export const bannerPCRoute: RouteItem = {
  title: 'Banner',
  hideChildrenInMenu: true,
  uuid: BANNER_LIST_PAGE_UUID,
  children: [
    {
      title: '列表',
      path: BANNER_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增',
      path: BANNER_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    },
    {
      title: '编辑',
      path: BANNER_EDIT_PAGE_PATH,
      Component: () => import('./Edit')
    },
    {
      title: '管理',
      uuid: BANNER_ACTION_UUID
    }
  ]
}
